/** Viewer's operational callsign — module-cached, shared across surfaces. */
import { useEffect, useState } from "react";
import { api } from "./commandApi";

let _cache = null;
let _promise = null;
const _subs = new Set();

const load = () => {
  if (!_promise) {
    _promise = api("/command/identity")
      .then((d) => { _cache = d; _subs.forEach((fn) => fn(d)); return d; })
      .catch(() => { _cache = { callsign: null, role: "anonymous" }; return _cache; });
  }
  return _promise;
};

export const refreshCallsign = () => { _cache = null; _promise = null; return load(); };

export const useCallsign = () => {
  const [identity, setIdentity] = useState(_cache);
  useEffect(() => {
    _subs.add(setIdentity);
    if (!_cache) load().then(setIdentity);
    return () => _subs.delete(setIdentity);
  }, []);
  return identity || { callsign: null, role: "anonymous" };
};
